import React, { useState } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';

const ExtensionBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  return (
    <div className="bg-primary-50 border border-primary-200 border-l-4 border-l-primary-600 p-6 mb-6 rounded-xl">
      <div className="flex justify-between">
        <div className="flex">
          <div className="flex-shrink-0">
            <img 
              src="/extension.png" 
              alt="ResuMemo Extension" 
              className="h-7 w-7 mr-3"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
              }}
            />
          </div>
          <div className="ml-3">
            <p className="text-base text-primary-900">
              <span className="font-medium">Save jobs faster!</span> Use our browser extension to save job listings with one click.
              <a 
                href="https://chromewebstore.google.com/detail/resumemo-job-saver/ikkpnjimfefekoncejhmidjdccllhcej"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2 inline-flex items-center text-primary-700 font-medium hover:text-primary-800 underline"
              >
                Chrome Extension <FiExternalLink className="ml-1 h-4 w-4" />
              </a>
              <a 
                href="https://microsoftedge.microsoft.com/addons/detail/resumemo-job-saver/iojjijickphenfolpklfdhipmnneencf"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2 inline-flex items-center text-primary-700 font-medium hover:text-primary-800 underline"
              >
                Edge Extension <FiExternalLink className="ml-1 h-4 w-4" />
              </a>
              
            </p>
          </div>
        </div>
        <button 
          type="button" 
          className="flex-shrink-0 ml-2"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss banner"
        >
          <FiX className="h-5 w-5 text-primary-600 hover:text-primary-800" />
        </button>
      </div>
    </div>
  );
};

export default ExtensionBanner;